import { z } from 'zod';

export const createSlug = z.string().transform((value) => {
  return value.toLowerCase().replace(/\s/g, '-');
});
